import {Base} from "@/api/Base"

export class AttendanceLogsDelete extends Base {
    path = "attendanceLogs/delete"
}